import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';


const EventGallery = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
  { id: 'all', label: 'All Events', icon: 'Grid' },
  { id: 'corporate', label: 'Corporate', icon: 'Briefcase' },
  { id: 'wedding', label: 'Weddings', icon: 'Heart' },
  { id: 'social', label: 'Social Events', icon: 'Users' }];


  const galleryItems = [
  {
    id: 1,
    category: 'corporate',
    title: 'Tech Conference Lunch',
    description: 'Full-day catering for 200+ attendees',
    image: "https://images.unsplash.com/photo-1719765868011-68a88e7db83d",
    imageAlt: 'Large corporate conference buffet with Italian sandwiches and salads arranged on long tables with business professionals in suits gathering around food stations',
    guests: 200,
    type: 'Lunch Service'
  },
  {
    id: 2,
    category: 'wedding',
    title: 'Garden Wedding Reception',
    description: 'Elegant Italian dinner service',
    image: "https://images.unsplash.com/photo-1634222635995-c31e2610b927",
    imageAlt: 'Outdoor wedding reception with white tablecloths and Italian appetizer platters featuring bruschetta and antipasto with floral centerpieces and string lights',
    guests: 150,
    type: 'Dinner Service'
  },
  {
    id: 3,
    category: 'corporate',
    title: 'Executive Board Meeting',
    description: 'Premium breakfast catering',
    image: "https://images.unsplash.com/photo-1729756461174-04d248b016b2",
    imageAlt: 'Executive boardroom with elegant breakfast spread featuring fresh cornetti and pastries on silver platters with coffee service and white china',
    guests: 25,
    type: 'Breakfast'
  },
  {
    id: 4,
    category: 'social',
    title: 'Birthday Celebration',
    description: 'Custom dessert bar and appetizers',
    image: "https://images.unsplash.com/photo-1694772238727-abf2591ece52",
    imageAlt: 'Festive birthday party dessert table with Italian pastries and custom cake decorated with fresh flowers and colorful balloons in background',
    guests: 80,
    type: 'Dessert Bar'
  },
  {
    id: 5,
    category: 'corporate',
    title: 'Product Launch Event',
    description: 'Passed appetizers and cocktail service',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d9322ec8-1764538642055.png",
    imageAlt: 'Modern corporate event space with servers passing Italian appetizers on silver trays to professionally dressed guests holding wine glasses',
    guests: 120,
    type: 'Cocktail Reception'
  },
  {
    id: 6,
    category: 'wedding',
    title: 'Intimate Wedding Dinner',
    description: 'Five-course Italian feast',
    image: "https://images.unsplash.com/photo-1691437909245-66fecfe0afcb",
    imageAlt: 'Romantic wedding dinner setup with candlelit tables featuring Italian multi-course meal presentation with wine glasses and rose petals',
    guests: 60,
    type: 'Dinner Service'
  },
  {
    id: 7,
    category: 'social',
    title: 'Holiday Office Party',
    description: 'Festive buffet and dessert station',
    image: "https://images.unsplash.com/photo-1606568940396-a278882988f6",
    imageAlt: 'Holiday party buffet with Italian dishes and festive decorations featuring red and green tablecloths with seasonal centerpieces and twinkling lights',
    guests: 100,
    type: 'Buffet Service'
  },
  {
    id: 8,
    category: 'corporate',
    title: 'Annual General Meeting',
    description: 'Continental breakfast and lunch',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1da8e9e86-1764538653802.png",
    imageAlt: 'Professional conference hall with dual catering stations showing breakfast pastries and lunch sandwiches with corporate branding and presentation screens',
    guests: 180,
    type: 'Full Day Service'
  },
  {
    id: 9,
    category: 'social',
    title: 'Anniversary Celebration',
    description: 'Elegant dinner and custom cake',
    image: "https://images.unsplash.com/photo-1699692414699-17018c170de9",
    imageAlt: 'Elegant anniversary dinner table with Italian cuisine beautifully plated and custom celebration cake with gold accents and fresh flowers',
    guests: 50,
    type: 'Dinner Service'
  }];


  const filteredItems = activeCategory === 'all' ?
  galleryItems :
  galleryItems?.filter((item) => item?.category === activeCategory);

  return (
    <section className="py-16 bg-background">
      <div className="container-custom">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 mb-4">
            <Icon name="Camera" size={18} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">Event Gallery</span>
          </div>
          <h2 className="font-serif text-4xl font-bold text-foreground mb-4">
            Our Catering in Action
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Explore our portfolio of successful events and celebrations
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {categories?.map((category) =>
          <button
            key={category?.id}
            onClick={() => setActiveCategory(category?.id)}
            className={`px-6 py-3 rounded-lg font-medium transition-all duration-300 flex items-center gap-2 ${
            activeCategory === category?.id ?
            'bg-primary text-primary-foreground shadow-warm' :
            'bg-card text-foreground hover:bg-muted'}`
            }>

              <Icon name={category?.icon} size={18} />
              {category?.label}
            </button>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredItems?.map((item) =>
          <div
            key={item?.id}
            className="bg-card rounded-2xl shadow-warm overflow-hidden hover:shadow-warm-lg transition-all duration-300 group">

              <div className="relative h-64 overflow-hidden">
                <Image
                src={item?.image}
                alt={item?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="flex items-center gap-2 text-primary-foreground">
                    <Icon name="Users" size={16} />
                    <span className="text-sm font-medium">{item?.guests} Guests</span>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-medium">
                    {item?.type}
                  </span>
                </div>
                <h3 className="font-serif text-xl font-bold text-foreground mb-2">
                  {item?.title}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {item?.description}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground mb-6">
            Want to see your event featured here?
          </p>
          <Button variant="outline" iconName="Calendar" iconPosition="left">
            Book Your Event
          </Button>
        </div>
      </div>
    </section>);

};

export default EventGallery;